export const API_REQUESTS = Object.freeze({
  AUTHENTICATED: 1009,
  WEBSOCKET: Object.freeze({}),
  PUBLIC: Object.freeze({}),
  PRIVATE: Object.freeze({
    GET_CUSTOMER_REVIEWS: 10166,
    ADD_CUSTOMER_REVIEW: 10167,
    UPDATE_CUSTOMER_REVIEW: 10168,
    DELETE_CUSTOMER_REVIEW: 10169,
    GET_ADMIN_PROFILES: 10170,
  }),
});
